import React from "react";
import { pick } from "lodash";
import equal from "deep-equal";
import Term from "../../../../utilities/transcriptLib/Term";
import { TYPE_ARRAY } from "../../../../utilities/transcriptLib/constants";
import Turn from "./Turn";
import connectToTranscript from "../connectToTranscript";
import PropsToStateComponent from "../../../../utilities/transcriptLib/PropsToStateComponent";
import compareRangeLists from "../../../../utilities/transcriptLib/compareRangeLists";
import S from "../../../../styles/components";

import connectToMedia from "../../../Media/connectToMedia";
class Content extends PropsToStateComponent {
  propsToState(pProps) {
    return pick(
      super.propsToState(pProps),
      "queries,speakers,speakerColors,transcriptsBySpeaker,transcriptTimeRanges,identifiedRangeBrackets".split(
        ","
      )
    );
  }

  shouldComponentUpdate(newProps, newState) {
    if (!equal(newProps.query, this.props.query)) return true;
    return (
      !compareRangeLists(
        newState.transcriptTimeRanges,
        this.state.transcriptTimeRanges
      ) ||
      !compareRangeLists(
        newProps.transcriptTimeRanges,
        newState.transcriptTimeRanges
      ) ||
      !equal(
        newState.identifiedRangeBrackets,
        this.state.identifiedRangeBrackets
      ) ||
      !compareRangeLists(
        newProps.identifiedRangeBrackets,
        newState.identifiedRangeBrackets
      )
    );
  }

  render() {
    const {
      speakers,
      speakerColors,
      transcriptsBySpeaker,
      isChatTextMedia,
      metadata,
      fullTurns,
    } = this.props;
    return (
      <S.TranscriptBody isChatTextMedia={isChatTextMedia}>
        {isChatTextMedia
          ? fullTurns.map((turn, index) => {
              return (
                <Turn
                  turnIndex={index}
                  metadata={metadata}
                  isChatTextMedia={isChatTextMedia}
                  turn={turn}
                  key={`${turn.text}_${index}`}
                  speakers={speakers}
                  speakerColors={speakerColors}
                />
              );
            })
          : transcriptsBySpeaker.value
              .filter(
                (turn) =>
                  turn &&
                  turn instanceof Term &&
                  turn.type === TYPE_ARRAY &&
                  turn.value.length
              )
              .map((turn) => {
                return (
                  <Turn
                    metadata={metadata}
                    isChatTextMedia={isChatTextMedia}
                    turn={turn}
                    key={turn.id}
                    speakers={speakers}
                    speakerColors={speakerColors}
                  />
                );
              })}
      </S.TranscriptBody>
    );
  }
}

export default connectToTranscript(Content);

/**
 propsToState(pProps) {
    return pick(super.propsToState(pProps),
      'speakers,speakerColors,transcriptsBySpeaker,transcriptTimeRanges,identifiedRangeBrackets'.split(','));
  }

 shouldComponentUpdate(newProps, newState) {
    return !compareRangeLists(newState.transcriptTimeRanges, this.state.transcriptTimeRanges)
      || !compareRangeLists(newProps.transcriptTimeRanges, newState.transcriptTimeRanges)
      || !equal(newState.identifiedRangeBrackets, this.state.identifiedRangeBrackets)
      || !compareRangeLists(newProps.identifiedRangeBrackets, newState.identifiedRangeBrackets);
  }
 */
